module.exports = __webpack_public_path__ + "static/servier-49d0ed2a326386e5bd037d7c4fbb5bd3.jpg";